var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, Button, InputLabel } from "@mui/material";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { getTemperatureConditionList } from "../../../../fieldFailureReports/services/apiCalls";
import { Attachment } from "../../../../fieldFailureReports/components/fieldFailureReportCreateForm/Attachment";
export var ProblemDescriptionOrChangeSequence1 = function () {
    var viewMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var showAFRsModelDetails = arguments.length > 1 ? arguments[1] : undefined;
    return [{
            type: FormItemTypes.CardComponent,
            name: "",
            xs: 12,
            sm: 12,
            md: 6,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "CauseOFFaillureObservedDuringPrepare",
                    label: /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1
                        }
                    }, /*#__PURE__*/ React.createElement(InputLabel, {
                        sx: {
                            fontWeight: "bold"
                        }
                    }, "Why? Cause of Failure Observed During Repair", /*#__PURE__*/ React.createElement("span", {
                        style: {
                            color: "red"
                        }
                    }, "*")), /*#__PURE__*/ React.createElement(Button, {
                        variant: "text",
                        size: "small",
                        onClick: function () {
                            showAFRsModelDetails && showAFRsModelDetails({
                                key: "ReferenceValuesCauseOfFailureObservedDuringRepair",
                                title: "Why? Cause of failure observed during repair(Reference values)"
                            });
                        }
                    }, "Reference values")),
                    validator: function (value, state) {
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Please fill \"Why? Cause of Failure Observed During Repair\"";
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Cause of Failure must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                            return 'Cause of Failure must be at least 250 characters';
                        }
                        return undefined;
                    },
                    columnSize: 12,
                    sx: {
                        "& .MuiIcon-colorError": {
                            display: "none"
                        }
                    },
                    multiline: true,
                    minRows: 4
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            xs: 12,
            sm: 12,
            md: 6,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "HowYouIdentifiedDefectivePart",
                    validator: function (value, state) {
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Please fill \"How? How You Identified Defective Part\"";
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Defective Part must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                            return 'Defective Part must be at least 250 characters';
                        }
                        return undefined;
                    },
                    label: /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1
                        }
                    }, /*#__PURE__*/ React.createElement(InputLabel, {
                        sx: {
                            fontWeight: "bold"
                        }
                    }, "How? How You Identified Defective Part?", /*#__PURE__*/ React.createElement("span", {
                        style: {
                            color: "red"
                        }
                    }, "*")), /*#__PURE__*/ React.createElement(Button, {
                        variant: "text",
                        size: "small",
                        onClick: function () {
                            showAFRsModelDetails && showAFRsModelDetails({
                                key: "ReferenceValuesHowYouIdentifiedDefectivePart",
                                title: "How? How you identified defective part?(Reference values)"
                            });
                        }
                    }, "Reference values")),
                    columnSize: 12,
                    sx: {
                        "& .MuiIcon-colorError": {
                            display: "none"
                        }
                    },
                    multiline: true,
                    minRows: 4
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            xs: 12,
            sm: 12,
            md: 6,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "TemporaryActionTakenInField",
                    validator: function (value, state) {
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Please fill \"Temporary actions taken in field (Reference values)\"";
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Temporary actions must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                            return 'Temporary actions must be at least 250 characters';
                        }
                        return undefined;
                    },
                    label: /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1
                        }
                    }, /*#__PURE__*/ React.createElement(InputLabel, {
                        sx: {
                            fontWeight: "bold"
                        }
                    }, "Temporary Actions Taken in Field", /*#__PURE__*/ React.createElement("span", {
                        style: {
                            color: "red"
                        }
                    }, "*")), /*#__PURE__*/ React.createElement(Button, {
                        variant: "text",
                        size: "small",
                        onClick: function () {
                            showAFRsModelDetails && showAFRsModelDetails({
                                key: "ReferenceValuesTemporaryActionTakenInField",
                                title: "Temporary actions taken in field (Reference values)"
                            });
                        }
                    }, "Reference values")),
                    columnSize: 12,
                    sx: {
                        "& .MuiIcon-colorError": {
                            display: "none"
                        }
                    },
                    multiline: true,
                    minRows: 4
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            xs: 12,
            sm: 12,
            md: 6,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "ParameterChecked",
                    validator: function (value, state) {
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Please fill \"Parameters checked\"";
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Parameters checked must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                            return 'Parameters checked must be at least 250 characters';
                        }
                        return undefined;
                    },
                    label: /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1
                        }
                    }, /*#__PURE__*/ React.createElement(InputLabel, {
                        sx: {
                            fontWeight: "bold"
                        }
                    }, "Parameters checked", /*#__PURE__*/ React.createElement("span", {
                        style: {
                            color: "red"
                        }
                    }, "*")), /*#__PURE__*/ React.createElement(Button, {
                        variant: "text",
                        size: "small",
                        onClick: function () {
                            showAFRsModelDetails && showAFRsModelDetails({
                                key: "ReferenceValuesParameterChecked",
                                title: "Parameters checked"
                            }, true);
                        }
                    }, "Reference values")),
                    columnSize: 12,
                    sx: {
                        "& .material-icons": {
                            display: "none"
                        }
                    },
                    multiline: true,
                    minRows: 4
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    alignItems: "center",
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: "",
                            children: "Customer complaints",
                            columnSize: true,
                            fontWeight: "bold"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            variant: "text",
                            children: "Reference values",
                            columnSize: 0,
                            onClick: function () {
                                showAFRsModelDetails && showAFRsModelDetails({
                                    key: "ReferenceValuesCustomerComplaints",
                                    title: "Customer complaints (Reference values)"
                                }, true);
                            }
                        }]
                }, {
                    type: FormItemTypes.TextInput,
                    name: "ProblemDescription",
                    multiline: true,
                    required: true,
                    minRows: 4,
                    label: "What (Problem Description)",
                    xs: 12,
                    sm: 12,
                    md: 6,
                    validator: function (value, state) {
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Problem Description cannot be left blank";
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Problem Description must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 30) {
                            return 'Problem Description must be no longer than 30 characters';
                        }
                        return undefined;
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: "RoadCondition",
                    multiline: true,
                    required: true,
                    minRows: 4,
                    label: "Where (Road Condition)",
                    xs: 12,
                    sm: 12,
                    md: 6,
                    validator: function (value, state) {
                        var nameRegex = /^[A-Za-z\s]+$/;
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Road Condition cannot be left blank";
                        }
                        if (!nameRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return 'Only alphabetic characters are allowed';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Road Condition must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 30) {
                            return 'Road Condition must be no longer than 30 characters';
                        }
                        return undefined;
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: "When",
                    name: "TemperatureConditionId",
                    value: null,
                    required: true,
                    getListData: getTemperatureConditionList,
                    displayExpr: "Name",
                    valueExpr: "id",
                    xs: 12,
                    sm: 12,
                    md: 6
                }, {
                    type: FormItemTypes.TextInput,
                    name: "VehicleSpeed",
                    label: "Vehicle speed (Km/Hr)",
                    required: true,
                    xs: 12,
                    sm: 12,
                    md: 6
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            columnSize: 12,
            sx: {
                mb: 9
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    alignItems: "center",
                    columnSize: 12,
                    spacing: 0,
                    elements: __spreadArray([{
                            type: FormItemTypes.Typography,
                            name: "",
                            children: "Customer complaints",
                            columnSize: true,
                            fontWeight: "bold"
                        }], Attachment, true)
                }]
        }];
};
